import React from 'react';
import PermissionGate from './PermissionGate';

function CadastrarUsuarioFormulario({ obj, cadastrarUsuario, alterarUsuario, empresas, remover, ativar, inativar, eventoTeclado, perfis, botao }) {
  return (
    <form>
      <div className="modal-form-field">
        <input
          type="text"
          value={obj.name}
          onChange={eventoTeclado}
          name='name'
          placeholder="Nome"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="email"
          value={obj.email}
          onChange={eventoTeclado}
          name='email'
          placeholder="Email"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="password"
          value={obj.password}
          onChange={eventoTeclado}
          name='password'
          placeholder="Senha"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <input
          type="text"
          value={obj.phone}
          onChange={eventoTeclado}
          name='phone'
          placeholder="Telefone"
          className='form-control'
        />
      </div>

      <div className="modal-form-field">
        <select
          value={obj.idEmpresa}
          onChange={eventoTeclado}
          name='idEmpresa'
          className='form-control'
        >
          <option value="">Selecione uma empresa</option>
          {empresas.map((empresa) => (
            <option key={empresa.id} value={empresa.id}>
              {empresa.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="modal-form-field">
        <select
          value={obj.perfilId}
          onChange={eventoTeclado}
          name='perfilId'
          className='form-control'
        >
          <option value="">Selecione um perfil</option>
          {perfis.map((perfil) => (
            <option key={perfil.id} value={perfil.id}>
              {perfil.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="modal-buttons">
        {botao ? (
          <div className="modal-actions">
            <PermissionGate permissions={["cadastrarUsuarios"]}>
              <button type="button" onClick={cadastrarUsuario} className='modal-button modal-button-primary'>
                Cadastrar
              </button>
            </PermissionGate>
          </div>
        ) : (
          <div className="modal-actions">
            <PermissionGate permissions={["cadastrarUsuarios"]}>
              <button type="button" onClick={alterarUsuario} className='modal-button modal-button-warning'>
                Alterar
              </button>
            </PermissionGate>

            <PermissionGate permissions={["cadastrarUsuarios"]}>
              <button type="button" onClick={remover} className='modal-button modal-button-danger'>
                Remover
              </button>
            </PermissionGate>

            <PermissionGate permissions={["cadastrarUsuarios"]}>
              <button type="button" onClick={ativar} className='modal-button modal-button-secondary'>
                Ativar
              </button>
            </PermissionGate>

            <PermissionGate permissions={["cadastrarUsuarios"]}>
              <button type="button" onClick={inativar} className='modal-button modal-button-secondary'>
                Inativar
              </button>
            </PermissionGate>
          </div>
        )}
      </div>
    </form>
  );
}

export default CadastrarUsuarioFormulario;